import { render, staticRenderFns } from "./CaixaResumoDropdown.vue?vue&type=template&id=718bdf1c&scoped=true"
import script from "./CaixaResumoDropdown.vue?vue&type=script&lang=js"
export * from "./CaixaResumoDropdown.vue?vue&type=script&lang=js"
import style0 from "./CaixaResumoDropdown.vue?vue&type=style&index=0&id=718bdf1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718bdf1c",
  null
  
)

export default component.exports